var publicPath = __webpack_public_path__;
            var symbolUrl = 'img/sprite.3d7967c1.svg#icon-play';
            var viewUrl = 'img/sprite.3d7967c1.svg#view-icon-play';

            

            module.exports = {
                symbol: publicPath + symbolUrl,
                view: publicPath + viewUrl,
                viewBox: '0 0 80 80',
                title: 'play',
                toString: function () {
                    return JSON.stringify(this.view);
                }
            };